// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0e8cf9d3","977":"a145346f"}[chunkId] + ".chunk.js";
};